import { supabase, applyOrgFilter, getActiveOrgOverride, DEFAULT_ORG_ID } from '../supabaseClient';
import { getCurrentStaff } from './auth';

export async function getAllLigas() {
  let query = supabase
    .from('ligas')
    .select('*')
    .eq('activo', true)
    .is('deleted_at', null)
    .order('nombre');

  query = applyOrgFilter(query);

  const { data, error } = await query;
  if (error) {
    console.error('[getAllLigas] Error:', error);
  }
  return { data, error };
}

export async function getLigaById(ligaId) {
  const { data, error } = await supabase
    .from('ligas')
    .select('*')
    .eq('id', ligaId)
    .single();

  if (error) {
    console.error('[getLigaById] Error:', error);
    throw error;
  }
  return data;
}

export async function createLiga(ligaData) {
  const orgId = getActiveOrgOverride() || ligaData?.org_id || (await getCurrentStaff())?.data?.org_id || DEFAULT_ORG_ID;
  const { data, error } = await supabase
    .from('ligas')
    .insert([{ ...ligaData, org_id: orgId }])
    .select()
    .single();

  if (error) {
    console.error('[createLiga] Error:', error);
    throw error;
  }
  return data;
}

export async function updateLiga(ligaId, ligaData) {
  const { data, error } = await supabase
    .from('ligas')
    .update(ligaData)
    .eq('id', ligaId)
    .select()
    .single();

  if (error) {
    console.error('[updateLiga] Error:', error);
    throw error;
  }
  return data;
}

export async function deleteLiga(ligaId) {
  const { data, error } = await supabase
    .from('ligas')
    .update({
      activo: false,
      deleted_at: new Date().toISOString()
    })
    .eq('id', ligaId)
    .select()
    .single();

  if (error) {
    console.error('[deleteLiga] Error:', error);
    throw error;
  }
  return data;
}
